import { gql } from '@apollo/client';

export default gql`
  mutation updatePassengers($bookingReference: String!, $passengers: [InputPassenger]!) {
    updatePassengers(bookingReference: $bookingReference, passengers: $passengers) {
      reference
    }
  }
`;
